// extracted by mini-css-extract-plugin
module.exports = {"category":"_2tL3cCw _2t5guGG","categoryHeader":"_1YIYGPD _2znJ6SM","title":"_2usYY3B","subHeader":"XrN-Jyi"};